// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".annotation--IAPWQ1-g {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", \"Consolas\", \"source-code-pro\",\n    monospace;\n  font-size: 12px;\n  opacity: 0.7;\n  color: var(--text-color-secondary);\n  margin-left: 7px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-shrink: 10000;\n  transition: color 3s 1s;\n}\n\n.changed--2YYXenE5 {\n  color: var(--palette-red-6);\n  transition: color 0.1s;\n}\n\n.clickable--1hbQJOuT {\n  cursor: pointer;\n}\n\n.clickable--1hbQJOuT:hover {\n  opacity: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"annotation": "annotation--IAPWQ1-g",
	"changed": "changed--2YYXenE5",
	"clickable": "clickable--1hbQJOuT"
};
export default ___CSS_LOADER_EXPORT___;
